declare var swal: any;
import { Component, OnInit,Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, TreatmentCyclesController, TreatmentCyclesRequest, IvfWorkbenchController, IvfWorkbenchRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, FollicularScanDetailController, FollicularScanDetailRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, SaveIvfCycleTestDataRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbEventAddModal } from '../TreatmentCycle/eventadd.modal';
import { ActivitesPipe, TestPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgbEditScanTestModal } from './editscantest.modal';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';





@Component({
  selector: 'testview',
    templateUrl: './testview.component.html',
  styleUrls: [
    './testview.component.scss']
  ,animations: [routerTransition()]
})

export class TestViewComponent implements OnInit {
  
  
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
    @Input() ActorCode: number;
    @Input() CycleCode: number;
    @Input() LMPDate: Date;
  @Input() Title: string;
  @Input() SourceType: string;
  //public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public Showivfbench: boolean = true;
  public ScanDetails: boolean = false;
  public PickUpDetails: boolean = false;
  public ETDetails: boolean = false;
  public SADetails: boolean = false;
  public InseminationDetails: boolean = false;
  public OQADetails: boolean = false;
  public GradingDetails: boolean = false;
    public FreezingDetails: boolean = false;
    public EggSourceActorCode: number;
  searchTitle: string;
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
    public ApiResData: ApiResponseModel;
    public ScanDate: Date;

    CurrentFollicularScanDetailController: FollicularScanDetailController[];
    FollicularScanEndInfo: FollicularScanDetailController;
    CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;

    LoadScansData() {
        //alert("ScansData")
        this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularScanDetailController();
    }

    GetFollicularScanDetailController() {
        this.StartRefreshing();
        this.CurrentFollicularScanDetailRequest.ConditionalOperator = 20;
        this.CurrentFollicularScanDetailRequest.ScanCode = 0;
        this.CurrentFollicularScanDetailRequest.CycleCode = this.CycleCode;
        this.CurrentFollicularScanDetailRequest.PatientCode = 0;

        //alert(this.FormattedCode);
        this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularScanDetailController = this.ApiResData.Result;
                    this.FollicularScanEndInfo = this.CurrentFollicularScanDetailController[0];
                    this.ScanDate = this.CurrentFollicularScanDetailController[0].ScanDate;

                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.LoadPatients();
                    //   this.LoadGuardian();
                    //this.LoadMessages();

                    //this.LoadOvaryData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;
  CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    this.EggSourceActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    //this.LoadPlan();
                    this.LoadMasterReq();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //this.LoadTestData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ActorCode: number, ScanDate: Date): TreatmentCycleActiityMasterController[] {
        //alert(ActorCode);
        //alert(ScanDate);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ActorCode && v.DocDate == ScanDate;
            }
        )

    }
    CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
    CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

    LoadTestData() {
        //alert("ScansData")
        this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.pdata = this.CurrentIvfCycleTestByCodeController;
        this.GetIvfCycleTestByCodeController();
    }

    GetIvfCycleTestByCodeController() {
        this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 10;
        this.CurrentIvfCycleTestByCodeRequest.ActorCode = this.ActorCode;
        
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleTestByCodeRequest.ActivityCode = 0;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;
                    this.pdata = this.CurrentIvfCycleTestByCodeController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
      private route: ActivatedRoute,
    private filter: TestPipe,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }

  ngOnInit() {

   
    //this.GetPatientInfoByFormattedCodeController();
      //this.LoadPlan();
      //this.LoadScansData();
    this.LoadTestData();
    this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
    this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  EditTest(l: IvfCycleTestByCodeController) {

    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = l.ActorCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.ActivityCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = l.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
    this.CurrentSaveIvfCycleTestDataRequest.TestCode = l.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.TestName = l.TestName;
    this.CurrentSaveIvfCycleTestDataRequest.Remarks = l.Comments;
    this.CurrentSaveIvfCycleTestDataRequest.TestDate = l.TestDate;
    this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
    this.CurrentSaveIvfCycleTestDataRequest.Result = l.Result;
    this.CurrentSaveIvfCycleTestDataRequest.ResultUnits = l.ResultUnits;

    const modalRef = this.modalService.open(NgbEditScanTestModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CurrentSaveIvfCycleTestDataRequest = this.CurrentSaveIvfCycleTestDataRequest;
    modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
    //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
    //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }

  ShowList: boolean = true;
  delTEST(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {
      this.DeleteActorIdentitiesTest(l);
    }, function (dismiss) {
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesTest(l: any) {
    var item = l as IvfCycleTestByCodeController;
    console.log('..................');
    this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 30;
    this.CurrentSaveIvfCycleTestDataRequest.TestCode = item.TestCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = item.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = item.CycleActivity;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.ActorCode;
    this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.LoadTestData();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }
  
  //criteriaChange(value: any) {
   
  //}
  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  
 
  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  display(l: IvfWorkbenchController) {
    if (l.Name == "Scans") {
      this.router.navigate(['healins/ivfscans']);
    }
    else if (l.Name == "Ready for Pickup" || l.Name == "PickUps") {
      this.router.navigate(['healins/ivfpickups']);
    }
    else if (l.Name == "Oocyte Quality Assessment") {
      this.router.navigate(['healins/ivfoqa']);
    }
    else if (l.Name == "Insemination") {
      this.router.navigate(['healins/ivfinsemination']);
    }
    else if (l.Name == "EmbryoGrading") {
      this.router.navigate(['healins/ivfembryograding']);
    }
    else if (l.Name == "ReadyForTransfer") {
      this.router.navigate(['healins/ivffreezing']);
    }
    else if (l.Name == "FET Grading") {

    }
    else if (l.Name == "Calander") {

    }
    else if (l.Name == "") {

    }
}
  displayscans() {
    //this.Showivfbench = false;
    //this.ScanDetails = true;
    this.router.navigate(['healins/ivfscans']);
  }
  displaypickup() {
    //this.Showivfbench = false;
    //this.PickUpDetails = true;
    this.router.navigate(['healins/ivfpickups']);
  }
  displayet() {
    //this.Showivfbench = false;
    //this.ETDetails = true;
    this.router.navigate(['healins/ivfembryotransfer']);
  }
  displaysa() {
    //this.Showivfbench = false;
    //this.SADetails = true;
    this.router.navigate(['healins/ivfsemen']);
  }
  displayinsemination() {
    //this.Showivfbench = false;
    //this.InseminationDetails = true;
    this.router.navigate(['healins/ivfinsemination']);
  }
  displayoqa() {
    //this.Showivfbench = false;
    //this.OQADetails = true;
    this.router.navigate(['healins/ivfoqa']);
  }
  displaygrading() {
    //this.Showivfbench = false;
    //this.GradingDetails = true;
    this.router.navigate(['healins/ivfembryograding']);
  }
  displayfreezing() {
    //this.Showivfbench = false;
    //this.FreezingDetails = true;
    this.router.navigate(['healins/ivffreezing']);
  }
  //AddNewPatient() {
    
  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
  //  //modalRef.componentInstance.ActorCode = this.ActorCode;
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {
    
    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

 
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

    }
    pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentIvfCycleTestByCodeController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentIvfCycleTestByCodeController,
                    this.listFilter);
            }
        }
    }
   

  //SelectedPatient: PatientInfoByFormattedCodeController;
  //ViewPatientDetails(objCategory: any) {
  //  var patient: PatientInfoByFormattedCodeController = objCategory;

  //  if (patient != null) {

      
      
  //    this.ShowPatientDetails = true;
  //    this.ShowList = false;
  //    this.SelectedPatient = patient;
  //    this.Showarrow = true;
  //    this.Showrow = false;
  //    //this.LoadPatientdetails()
     
  //  }
  //  else {
  //    this.ShowPatientDetails = false;
  //  }
  //}
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {
   
   
  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();
   
  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  SelectedPatient: TreatmentCyclesController;
  ViewPatientDetails(objCategory: any) {
    var patient: TreatmentCyclesController = objCategory;
    if (patient != null) {
      this.SelectedPatient = null;
      this.SelectedPatient = patient;
      this.ShowList = false;
      this.ShowPatientDetails = true;
      this.Showarrow = false;
      this.Showrow = false;
      //this.ShowData = false;
      
    }
    else {
     
    }
    
  }
   

 

}
